// PDP — drag-to-pour interaction
(function () {
  const section = document.querySelector('[data-pdp-section]');
  if (!section) return;
  const stage = section.querySelector('[data-pdp-stage]');
  const tin = section.querySelector('[data-pdp-tin]');
  const bowl = section.querySelector('[data-pdp-bowl]');
  const pctEl = section.querySelector('[data-pdp-pct]');
  const barEl = section.querySelector('[data-pdp-bar]');
  const cueEl = section.querySelector('[data-pdp-cue]');
  const tinColor = section.dataset.productColor || '#7ba428';
  let pour = 0;

  function updateBowl() {
    const fillH = pour * 70;
    const rect = bowl.querySelector('rect');
    if (rect) {
      rect.setAttribute('y', 170 - fillH);
      rect.setAttribute('height', 180);
      rect.setAttribute('fill', tinColor);
    }
    if (pctEl) pctEl.textContent = Math.round(pour * 100) + '%';
    if (barEl) barEl.style.width = (pour * 100) + '%';
    if (cueEl) cueEl.textContent = pour < 0.05 ? 'tip the tin →' : pour < 0.5 ? 'keep going...' : pour < 0.95 ? 'almost!' : 'perfect 🍵';
  }

  let dragging = false, sx, sy, baseX = 0, baseY = 0;
  const onDown = (e) => {
    e.preventDefault();
    dragging = true;
    const pt = e.touches ? e.touches[0] : e;
    sx = pt.clientX; sy = pt.clientY;
    tin.style.cursor = 'grabbing';
  };
  const onMove = (e) => {
    if (!dragging) return;
    const pt = e.touches ? e.touches[0] : e;
    const dx = pt.clientX - sx, dy = pt.clientY - sy;
    const rot = Math.max(-90, Math.min(90, dx * 0.4));
    tin.style.transform = `translate(${dx}px, ${dy}px) rotate(${rot}deg)`;
    if (Math.abs(rot) > 30) {
      pour = Math.min(1, pour + 0.012);
      updateBowl();
      if (Math.random() < 0.4) emitParticle();
    }
  };
  const onUp = () => {
    dragging = false;
    tin.style.cursor = 'grab';
    tin.style.transition = 'transform 0.4s cubic-bezier(.5,1.5,.6,1)';
    tin.style.transform = '';
    setTimeout(() => { tin.style.transition = ''; }, 400);
  };

  function emitParticle() {
    const r = tin.getBoundingClientRect();
    const sR = stage.getBoundingClientRect();
    const p = document.createElement('div');
    p.className = 'pour-particle';
    p.style.cssText = `left:${r.left + r.width / 2 - sR.left}px;top:${r.bottom - sR.top}px;background:${tinColor};`;
    stage.appendChild(p);
    let vx = (Math.random() - 0.5) * 2, vy = 1 + Math.random() * 2;
    let x = parseFloat(p.style.left), y = parseFloat(p.style.top);
    const tick = () => {
      vy += 0.3; x += vx; y += vy;
      p.style.left = x + 'px'; p.style.top = y + 'px';
      if (y < sR.height + 100) requestAnimationFrame(tick);
      else p.remove();
    };
    requestAnimationFrame(tick);
    setTimeout(() => p.remove(), 1200);
  }

  tin.addEventListener('mousedown', onDown);
  tin.addEventListener('touchstart', onDown);
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  window.addEventListener('touchmove', onMove);
  window.addEventListener('touchend', onUp);

  // variant pills
  const form = section.querySelector('[data-pdp-form]');
  if (form) {
    form.querySelectorAll('label.opt-pill input[type="radio"][name="id"]').forEach(input => {
      input.addEventListener('change', () => {
        form.querySelectorAll('label.opt-pill').forEach(l => l.classList.toggle('on', l.querySelector('input').checked));
        const price = parseInt(input.dataset.variantPrice, 10);
        const totalEl = section.querySelector('[data-pdp-total]');
        const priceEl = section.querySelector('[data-pdp-price]');
        if (priceEl) priceEl.textContent = ShopifyCart.formatMoney(price);
        if (totalEl) totalEl.textContent = ShopifyCart.formatMoney(price * (parseInt(form.querySelector('[data-qty-input]').value, 10) || 1));
      });
    });
    // qty stepper
    const qInput = form.querySelector('[data-qty-input]');
    const qDisp = form.querySelector('[data-qty-display]');
    form.querySelector('[data-qty-incr]')?.addEventListener('click', () => { qInput.value = (parseInt(qInput.value, 10) || 1) + 1; qDisp.textContent = qInput.value; });
    form.querySelector('[data-qty-decr]')?.addEventListener('click', () => { qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1); qDisp.textContent = qInput.value; });
  }
})();
